var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccountPropertySection',_vm._b({attrs:{"placeholder":_vm.t('settings', 'Your biography. Markdown is supported.'),"multi-line":true}},'AccountPropertySection',_vm.biography,false,true))
}
var staticRenderFns = []

export { render, staticRenderFns }